// import React, {useState} from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/bootstrap.css";
// import { Button } from "react-bootstrap";

// import './phone.css'

// export default function PhoneInp({formik}) {
//   const [phone, setPhone] = useState("");
// console.log('phone value',phone)
//   return (
//     <>
//       <div className="mb-2">
//         <span>Mobile</span>
//       </div>
//       <PhoneInput
//         country={"eg"}
//         enableSearch={true}
//         value={phone}
//         onChange={(phone) => setPhone(phone)}
//         inputStyle={{ padding: "6.5px 11px 7.5px 56px", width: "100%" }}
//       />
       
       
//     </>
    
//   );
// }

import React, { useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import './phone.css'

// import './reactPhone.css'

export default function PhoneInp({formik}) {

    const [value, setValue] = useState();

  return (
    <div>
      <label className='mb-2 sign_label'>Mobile</label>
      <PhoneInput
      international
      defaultCountry='PK'
      className='phoneInput'
       value={value}
       onChange={(e) => setValue(value)}
       limitMaxLength={true}
      //  maxLength={15}
      />
    </div>
  )
}
